export const hasTokenExpired = () => {
  const nowTs = new Date().getTime();
  const tokenCreationTs = parseInt(localStorage.getItem('token_creation_ts'));
  const ttlInSeconds = localStorage.getItem('ttl') * 60;
  return nowTs >= tokenCreationTs + ttlInSeconds;
};
